// extracted by mini-css-extract-plugin
module.exports = {"container_s":"styles_container_s__JIV2g"};